import { render, staticRenderFns } from "./emailreply.vue?vue&type=template&id=128b6dde&"
import script from "./emailreply.vue?vue&type=script&lang=js&"
export * from "./emailreply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports